export default __webpack_public_path__ + "static/media/hht2_ep2_speaking_03.0d7eb619.png";